import { AsyncPipe, DatePipe, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AssetDto, AssetVersionDto } from '@picflow/types';
import { getFullPath } from '../../../lib/get-full-path';
import { AssetService } from '../../../services/asset.service';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { AssetUrlPipe } from '../../../shared/pipes/asset-url.pipe';
import { AssetVersionUrlPipe } from '../../../shared/pipes/asset-version-url.pipe';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-asset-version-menu',
  templateUrl: './asset-version-menu.component.html',
  styleUrls: ['./asset-version-menu.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    SvgComponent,
    UpperCasePipe,
    DatePipe,
    AssetUrlPipe,
    AssetVersionUrlPipe,
    TranslatePipe,
    AsyncPipe,
    LoadingIndicatorComponent,
  ],
})
export class AssetVersionMenuComponent implements OnInit {
  private assetService = inject(AssetService);
  private route = inject(ActivatedRoute);
  private check = inject(ChangeDetectorRef);
  @Input() asset: AssetDto;
  @Input() versions: AssetVersionDto[];
  @Input() small = false;
  names: { [versionId: string]: { name: string; ext: string } };
  urlPrefix = '../';
  loading = signal(false);

  constructor() {
    const path = getFullPath(this.route.snapshot);
    if (!path.includes('version')) this.urlPrefix = 'version';
  }

  async ngOnInit() {
    this.names = {};
    this.names[this.asset.version_data.id] = this.calcName(this.asset.version_data);
    this.loading.set(true);
    const versions = await this.assetService.getAssetVersions(this.asset.id, <string>this.asset.gallery);
    this.versions = versions.filter(v => v.id !== this.asset.version);
    this.versions.sort((a, b) => (a.created_at > b.created_at ? -1 : 1));
    versions.forEach(v => (this.names[v.id] = this.calcName(v)));
    this.loading.set(false);
    this.check.detectChanges();
  }

  private calcName(version: AssetVersionDto) {
    const name = version.asset_name.split('.');
    const ext = name.pop();
    return {
      name: name.join('.'),
      ext,
    };
  }
}
